import { getBreadcrumbsWithHome } from '@bridebook/web/app-shared/lib/utils/get-breadcrumbs-with-home';
import { getI18n } from '@bridebook/web/lib/i18n/getI18n';
import { UrlHelper } from '@bridebook/web/lib/url-helper';

export const getBreadcrumbsArticles = (name: string, path: string = UrlHelper.advice) => {
  const i18n = getI18n();
  return getBreadcrumbsWithHome(name, [
    {
      name: i18n.t('articles:advice.breadcrumbs'),
      path,
      id: 'advice',
    },
  ]);
};
